import {AccessControlApi} from '../request/AccessControl/api'
import store from '../store'

function getCardCertType () {
  if (store.state.doorControl.certTypeList.length) {
    return
  }
  AccessControlApi.getTableList('001', {})
    .then(res => {
      if (res.retCode === '0000') {
        store.commit('doorControl/setCertTypeList', res.BizBodyMsg.codeList)
      }
    })
}

function getPersonType () {
  if (store.state.doorControl.personTypeList.length) {
    return
  }
  AccessControlApi.getTableList('002', {})
    .then(res => {
      if (res.retCode === '0000') {
        store.commit('doorControl/setPersonTypeList', res.BizBodyMsg.codeList)
      }
    })
}

function getStaffType () {
  if (store.state.doorControl.staffTypeList.length) {
    return
  }
  AccessControlApi.getTableList('003', {})
    .then(res => {
      if (res.retCode === '0000') {
        store.commit('doorControl/setStaffTypeList', res.BizBodyMsg.codeList)
      }
    })
}

function getPassType () {
  if (store.state.doorControl.passTypeList.length) {
    return
  }
  AccessControlApi.getTableList('004', {})
    .then(res => {
      if (res.retCode === '0000') {
        store.commit('doorControl/setPassTypeList', res.BizBodyMsg.codeList)
      }
    })
}
function getDeviceType () {
  if (store.state.doorControl.deviceTypeList.length) {
    return
  }
  AccessControlApi.getTableList('005', {})
    .then(res => {
      if (res.retCode === '0000') {
        store.commit('doorControl/setDeviceTypeList', res.BizBodyMsg.codeList)
      }
    })
}
function getOpenMode (deviceType = '0') {
  // if (store.state.doorControl.openModeList.length) {
  //   return
  // }
  AccessControlApi.getTableList('006', {deviceType: deviceType})
    .then(res => {
      if (res.retCode === '0000') {
        store.commit('doorControl/setOpenModeList', res.BizBodyMsg.codeList)
      }
    })
}
function getWarnType () {
  if (store.state.doorControl.warnTypeList.length) {
    return
  }
  AccessControlApi.getTableList('007', {})
    .then(res => {
      if (res.retCode === '0000') {
        store.commit('doorControl/setWarnTypeList', res.BizBodyMsg.codeList)
      }
    })
}

function getChooseDeviceList (type = '1') {
  if (store.state.doorControl.chooseDeviceList.length) {
    return
  }
  AccessControlApi.getTableList('008', {deviceType: type})
    .then(res => {
      if (res.retCode === '0000') {
        store.commit('doorControl/setChooseDeviceList', res.BizBodyMsg.codeList)
      }
    })
}

function getDepartmentList () {
  // if (store.state.doorControl.departmentList.length) {
  //   return
  // }
  AccessControlApi.queryDepartment({
    departmentId: '',
    departmentName: '',
    pageNum: '1',
    pageSize: '999'
  })
    .then(res => {
      if (res.retCode === '0000') {
        let departmentList = res.BizBodyMsg.departmentList
        // 对列表显示字段的上级部门进行拼接
        for (let depart of departmentList) {
          if (depart.upDepartmentName) {
            depart.departmentName = depart.upDepartmentName + '|' + depart.departmentName
          }
        }
        let replaceDepartment = JSON.parse(JSON.stringify(departmentList).replace(/departmentName/g, 'codeName').replace(/departmentId/g, 'codeNo'))
        // console.log(bbb, res.BizBodyMsg.departmentList)
        // console.log(res.BizBodyMsg.departmentList, replaceDepartment)
        store.commit('doorControl/setDepartmentList', replaceDepartment)
      }
    })
}

function setGroupOption () {
  if (store.state.groupOption.isSet) {
    // return
  }
  // let option = []
}

let getType = {
  getCardCertType, getPersonType, getStaffType, getPassType, getDeviceType, getOpenMode, getWarnType, getDepartmentList, setGroupOption, getChooseDeviceList
}

export {getType}



// WEBPACK FOOTER //
// ./src/util/handlePullDownList.js